import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Logistics',
    main: [
      {
        state: 'dashboard',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-dashboard'
      },
      {
        state: 'users',
        name: 'Users',
        type: 'link',
        icon: 'ti-user'
      },
      /* {
        state: 'admins',
        name: 'Admins',
        type: 'link',
        icon: 'ti-user'
      },
      {
        state: 'drivers',
        name: 'Drivers',
        type: 'link',
        icon: 'ti-truck'
      },
      {
        state: 'supervisors',
        name: 'Supervisors',
        type: 'link',
        icon: 'ti-truck'
      }, */
      {
        state: 'customers',
        name: 'Customers',
        type: 'link',
        icon: 'ti-crown'
      },
      {
        state: 'contacts',
        name: 'Contacts',
        type: 'link',
        icon: 'ti-agenda'
      }
    ]
  },
  {
    label: 'Branch',
    main: [
        {
          state: 'branches',
          name: 'Branches',
          type: 'link',
          icon: 'ti-map-alt'
        },
        {
          state: 'cities',
          name: 'Cities',
          type: 'link',
          icon: 'ti-map-alt'
        }
      ]
  },
  {
    label: 'Shipment',
    main: [
        {
          state: 'add-shipment',
          name: 'Add Shipment',
          type: 'link',
          icon: 'ti-package'
        },
        {
          state: 'manage-shipment',
          name: 'Manage Shipment',
          type: 'link',
          icon: 'ti-dropbox'
        },
        {
          state: 'barcodes',
          name: 'Barcode',
          type: 'link',
          icon: 'ti-layout-list-post'
        }
      ]
  },
  {
    label: 'Finance',
    main: [
      {
        state: 'finance-dashboard',
        name: 'Overview',
        type: 'link',
        icon: 'ti-info-alt'
      },
      {
        state: 'finance',
        name: 'Sales',
        type: 'link',
        icon: 'ti-money'
      },
      // {
      //   state: 'finance-account',
      //   name: 'Accounts',
      //   type: 'link',
      //   icon: 'ti-harddrives'
      // },
      {
        state: 'finance-transactions',
        name: 'Transactions',
        type: 'link',
        icon: 'ti-notepad'
      },
      {
        state: 'profit-loss',
        name: 'Proft Loss',
        type: 'link',
        icon: 'ti-pulse'
      },
      {
        state: 'finance-settings',
        name: 'Settings',
        type: 'link',
        icon: 'ti-settings'
      }
      ]
  },
  {
    label: 'Fleet management',
    main: [
      {
        state: 'fleet-dashboard',
        name: 'Overview',
        type: 'link',
        icon: 'ti-info-alt'
      },
        {
          state: 'vehicles',
          name: 'Vehicles',
          type: 'link',
          icon: 'ti-truck'
        },
        {
          state: 'expenses',
          name: 'Expenses',
          type: 'link',
          icon: 'ti-notepad'
        },
        {
          state: 'vehicle-inspection',
          name: 'Vehicle Inspection',
          type: 'link',
          icon: 'ti-panel'
        },
        {
          state: 'fleet-settings',
          name: 'settings',
          type: 'link',
          icon: 'ti-settings'
        }
      ]
  },
  {
    label: 'HRMS',
    main: [
        {
          state: 'hrms',
          name: 'Overview',
          type: 'link',
          icon: 'ti-info-alt'
        },
        {
          state: 'employees',
          name: 'Employees',
          type: 'link',
          icon: 'ti-user'
        },
        {
          state: 'leaves',
          name: 'Leaves',
          type: 'link',
          icon: 'ti-bag'
        },
        {
          state: 'attendance',
          name: 'Attendance',
          type: 'link',
          icon: 'ti-view-grid'
        },
        {
          state: 'company',
          name: 'Company',
          type: 'link',
          icon: 'ti-world'
        },
        {
          state: 'holidays',
          name: 'Holidays',
          type: 'link',
          icon: 'ti-flag-alt'
        },
        {
          state: 'payroll',
          name: 'Payroll',
          type: 'link',
          icon: 'ti-wallet'
        }
      ]
  }
];

const ADMINMENUITEMS = [
  {
    label: 'Logistics',
    main: [
      {
        state: 'dashboard',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-dashboard'
      },
      {
        state: 'users',
        name: 'Users',
        type: 'link',
        icon: 'ti-user'
      },
      /* {
        state: 'drivers',
        name: 'Drivers',
        type: 'link',
        icon: 'ti-truck'
      },
      {
        state: 'supervisors',
        name: 'Supervisors',
        type: 'link',
        icon: 'ti-truck'
      }, */
      {
        state: 'customers',
        name: 'Customers',
        type: 'link',
        icon: 'ti-crown'
      }
    ]
  },
  {
    label: 'Shipment',
    main: [
        {
          state: 'add-shipment',
          name: 'Add Shipment',
          type: 'link',
          icon: 'ti-package'
        },
        {
          state: 'manage-shipment',
          name: 'Manage Shipment',
          type: 'link',
          icon: 'ti-dropbox'
        },
        {
          state: 'barcodes',
          name: 'Barcode',
          type: 'link',
          icon: 'ti-layout-list-post'
        }
      ]
  },
  {
    label: 'Finance',
    main: [
      {
        state: 'finance',
        name: 'Finance',
        type: 'link',
        icon: 'ti-money'
      }
      ]
  },
  {
    label: 'Fleet management',
    main: [
        {
          state: 'vehicles',
          name: 'Vehicles',
          type: 'link',
          icon: 'ti-package'
        },
        {
          state: 'expenses',
          name: 'Expenses',
          type: 'link',
          icon: 'ti-dropbox'
        },
        {
          state: 'vehicle-inspection',
          name: 'vehicle-inspection',
          type: 'link',
          icon: 'ti-notepad'
        }
      ]
  },
  {
    label: 'HRMS',
    main: [
        {
          state: 'hrms',
          name: 'Overview',
          type: 'link',
          icon: 'ti-info-alt'
        },
        {
          state: 'employees',
          name: 'Employees',
          type: 'link',
          icon: 'ti-user'
        },
        {
          state: 'leaves',
          name: 'Leaves',
          type: 'link',
          icon: 'ti-bag'
        },
        {
          state: 'attendance',
          name: 'Attendance',
          type: 'link',
          icon: 'ti-view-grid'
        },
        {
          state: 'company',
          name: 'Company',
          type: 'link',
          icon: 'ti-world'
        },
        {
          state: 'holidays',
          name: 'Holidays',
          type: 'link',
          icon: 'ti-flag-alt'
        },
        {
          state: 'payroll',
          name: 'Payroll',
          type: 'link',
          icon: 'ti-wallet'
        }
      ]
  }
];
const DRIVERMENUITEMS = [
  {
    label: 'HRMS',
    main: [
        {
          state: 'hrms',
          name: 'Overview',
          type: 'link',
          icon: 'ti-info-alt'
        },
        {
          state: 'leaves',
          name: 'Leaves',
          type: 'link',
          icon: 'ti-bag'
        },
        {
          state: 'attendance',
          name: 'Attendance',
          type: 'link',
          icon: 'ti-view-grid'
        },
        {
          state: 'company',
          name: 'Company',
          type: 'link',
          icon: 'ti-world'
        },
        {
          state: 'holidays',
          name: 'Holidays',
          type: 'link',
          icon: 'ti-flag-alt'
        },
        {
          state: 'payroll',
          name: 'Payroll',
          type: 'link',
          icon: 'ti-wallet'
        }
      ]
  } 
];
@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    if(localStorage.getItem("courierapp_role") == "super admin")
    return MENUITEMS;
    else if(localStorage.getItem("courierapp_role") == "admin")
    return ADMINMENUITEMS;
    else 
    return DRIVERMENUITEMS
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/shared/menu-items/menu-items.ts